import React from "react";
import { View, StyleSheet, Platform, Pressable } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";

interface CourseInfoCardProps {
  icon: React.ReactNode;
  number: number;
  title: string;
  iconBackgroundColor: string;
  iconColor: string;
  borderColor?: string;
  isActive?: boolean;
  onPress?: () => void;
}

const CourseInfoCard: React.FC<CourseInfoCardProps> = ({
  icon,
  number,
  title,
  iconBackgroundColor,
  iconColor,
  borderColor,
  isActive = false,
  onPress,
}) => {
  return (
    <Pressable onPress={onPress} style={[styles.card, borderColor && { borderColor }, isActive && styles.cardActive]}>
      <View style={[styles.iconContainer, { backgroundColor: iconBackgroundColor }]}>
        {React.cloneElement(icon as React.ReactElement, {
          size: 22,
          color: iconColor,
          weight: "regular",
        })}
      </View>
      <View style={styles.content}>
        <CustomText
          useTranslationText={false}
          text={number.toString()}
          size="xs"
          weight="bold"
          style={styles.number}
          textType="display"
        />
        <CustomSpacing type="vertical" size="xs" />
        <CustomText useTranslationText={false} text={title} size="s" style={styles.title} />
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  card: {
    flexDirection: "row",
    alignItems: "center",
    padding: 18,
    backgroundColor: Platform.select({
      web: "rgba(255, 255, 255, 0.6)",
      default: "rgba(255, 255, 255, 0.95)",
    }),
    borderRadius: 16,
    borderWidth: 1,
    borderColor: "#EAECF0",
    ...(Platform.OS === "web"
      ? ({
          backdropFilter: "blur(4px)",
          WebkitBackdropFilter: "blur(4px)",
        } as any)
      : {}),
    flex: 1,
  },
  cardActive: {
    borderColor: "#3E68FE",
    backgroundColor: "#EEF4FF",
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 20,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 16,
  },
  content: {
    flex: 1,
  },
  number: {
    color: "#101828",
  },
  title: {
    color: "#475467",
  },
});

export default CourseInfoCard;
